"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("./Accordion.scss");
var _checkForThemeProps = require("../../utils/checkForThemeProps");
var _useStyles = _interopRequireDefault(require("../../utils/hooks/useStyles"));
var _AccordionItem = _interopRequireDefault(require("./AccordionItem"));
var _themes = require("../../utils/themes");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Accordion = _ref => {
  let {
    contentfulId,
    items,
    theme,
    disableIcon,
    paddingClass,
    setVisible
  } = _ref;
  if (typeof theme === "string" || theme instanceof String) {
    theme = _themes.terraThemes[theme];
  }
  const themes = (0, _checkForThemeProps.checkForThemeProps)(theme);
  const {
    backgroundColor,
    color,
    accordionIconColor
  } = (0, _useStyles.default)(themes);
  return /*#__PURE__*/_react.default.createElement("section", {
    className: `luna-accordion ${paddingClass}`,
    style: {
      background: backgroundColor
    }
  }, /*#__PURE__*/_react.default.createElement("section", {
    className: "luna-accordion__content-wrapper",
    style: {
      color: color
    },
    "data-sb-object-id": contentfulId ? contentfulId : null
  }, items && items.map((item, index) => {
    return /*#__PURE__*/_react.default.createElement(_AccordionItem.default, {
      key: index,
      item: item,
      iconColor: accordionIconColor,
      theme: theme,
      disableIcon: disableIcon,
      setVisible: setVisible
    });
  })));
};
var _default = Accordion;
exports.default = _default;
Accordion.propTypes = {
  items: _propTypes.default.array,
  theme: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  disableIcon: _propTypes.default.bool,
  paddingClass: _propTypes.default.string
};